<template>
  <div class="alert">
    <Transition name="slide-down">
      <div v-if="displayMessagesPool.length > 0" class="alert-container">
        <div class="alert-wrapper">
          <TransitionGroup name="slide-down">
            <div v-for="(message, index) in displayMessagesPool" :key="index">
              <div v-if="message.type === 'success'" class="alert-msg success">
                <div class="box">
                  <i class="material-icons">
                    done
                  </i>
                </div>
                <div class="text">
                  {{ message.message }}
                </div>
              </div>
              <div v-else-if="message.type === 'error'" class="alert-msg error">
                <div class="box">
                  <i class="material-icons">
                    report_problem
                  </i>
                </div>
                <div class="text">
                  {{ message.message }}
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Alert',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      displayMessagesPool: []
    }
  },
  computed: {
    ...mapState({
      message: state => state.alert.message,
      type: state => state.alert.type,
      duration: state => state.alert.duration,
      autoClose: state => state.alert.autoClose
    })
  },
  watch: {
    message(newMessage) {
      if (newMessage) {
        const displayMessageItem = {
          timestamp: new Date().getTime(),
          message: this.$te(newMessage) ? this.$t(newMessage) : newMessage,
          type: this.type,
          duration: this.duration,
          autoClose: this.autoClose
        }
        this.displayMessagesPool.push(displayMessageItem)
        if (this.autoClose) {
          this.closeAutomatically(displayMessageItem)
        }
        this.$store.commit('ALERT_MESSAGE_RESET')
      }
    }
  },
  mounted() {
    // Usage example
    // setTimeout(() => {
    //   this.$store.commit('ALERT_MESSAGE', {
    //     message: 'Test alert message.',
    //     type: 'success',
    //     duration: 2500,
    //     autoClose: true
    //   })
    // }, 1000)
  },
  methods: {
    closeAutomatically(message) {
      setTimeout(() => {
        const removeIndex = this.displayMessagesPool.findIndex(item => item.timestamp === message.timestamp)
        this.displayMessagesPool.splice(removeIndex, 1)
      }, this.duration)
    }
  }
}
</script>

<style lang="scss" scoped>
.alert {
  &-container {
    z-index: 10000;
    position: fixed;
    left: 0;
    top: 16vh;
    width: 100vw;
    height: 55px;
  }
  &-wrapper {
    height: 55px;
    width: 526px;
    margin: 0 auto;
  }
  &-msg {
    position: relative;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 20px;
    // font-weight: 500;
    // line-height: 1.95;
    line-height: 55px;
    letter-spacing: -0.1px;
    .box {
      position: relative;
      overflow: hidden;
      float: left;
      border-radius: 8px 0 0 8px;
      height: 55px;
      width: 56px;
      text-align: center;
      i {
        line-height: 55px;
      }
    }
    .text {
      position: relative;
      overflow: hidden;
      border-radius: 0 8px 8px 0;
      padding: 0 16px;
      text-align: left;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .success {
    .box {
      color: #ffffff;
      background-color: #417505;
    }
    .text {
      color: #417505;
      background-color: #ffffff;
    }
  }
  .error {
    .box {
      color: #ffffff;
      background-color: #d0021b;
    }
    .text {
      color: #d0021b;
      background-color: #ffffff;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .alert {
    &-wrapper {
      max-width: calc(100% - (24px * 2));
      .text {
        font-size: 16px;
      }
    }
  }
}
</style>
